export enum LangEnum {
  ES_MX = 'es-MX',
  EN_US = 'en-US',
  FR_FR = 'fr-FR',
  DE_DE = 'de-DE',
  IT_IT = 'it-IT',
  JA_JP = 'ja-JP',
  KO_KR = 'ko-KR',
  PT_BR = 'pt-BR',
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
}
